"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Avatar = exports.BaseAvatar = exports.InitialsHolder = exports.sizeValue = exports.Size = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _styledSystem = require("styled-system");

var _color = require("../../helpers/color");

var _Flex = require("../Flex");

var _LazyImage = require("../Image/LazyImage");

var _Typography = require("../Typography");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/** Size */
var Size = {
  xxs: {
    diameter: "30px",
    typeSize: "3"
  },
  xs: {
    diameter: "45px",
    typeSize: "3"
  },
  sm: {
    diameter: "70px",
    typeSize: "6"
  },
  md: {
    diameter: "100px",
    typeSize: "8"
  }
};
exports.Size = Size;

/** sizeValue */
var sizeValue = function sizeValue(size) {
  switch (size) {
    case "xxs":
      return Size.xxs;

    case "xs":
      return Size.xs;

    case "sm":
      return Size.sm;

    case "md":
    default:
      return Size.md;
  }
};
/** InitialsHolder */


exports.sizeValue = sizeValue;
var InitialsHolder = (0, _styledComponents.default)(_Flex.Flex).withConfig({
  displayName: "Avatar__InitialsHolder",
  componentId: "sc-1vf60gh-0"
})(["background-color:", ";text-align:center;overflow:hidden;", ""], (0, _color.color)("black10"), _styledSystem.borderRadius);
exports.InitialsHolder = InitialsHolder;
InitialsHolder.displayName = "InitialsHolder";

/** An circular Avatar component containing an image or initials */
var BaseAvatar = function BaseAvatar(_ref) {
  var src = _ref.src,
      initials = _ref.initials,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "md" : _ref$size,
      renderAvatar = _ref.renderAvatar;

  var _sizeValue = sizeValue(size),
      diameter = _sizeValue.diameter,
      typeSize = _sizeValue.typeSize;

  if (src) {
    return renderAvatar();
  } else if (initials) {
    // Left align for overflow
    var justifyContent = initials.length > 4 ? "left" : "center";
    return /*#__PURE__*/_react.default.createElement(InitialsHolder, {
      width: diameter,
      height: diameter,
      justifyContent: justifyContent,
      alignItems: "center" // NOTE: To make a circle in React Native:
      // you have to use a numeric value and can't use "50%"
      ,
      borderRadius: diameter
    }, /*#__PURE__*/_react.default.createElement(_Typography.Sans, {
      size: typeSize,
      color: "black60",
      weight: "medium",
      lineHeight: parseInt(diameter, 10)
    }, initials));
  } else {
    return null;
  }
};
/** An circular Avatar component containing an image or initials */


exports.BaseAvatar = BaseAvatar;

var Avatar = function Avatar(_ref2) {
  var src = _ref2.src,
      initials = _ref2.initials,
      _ref2$lazyLoad = _ref2.lazyLoad,
      lazyLoad = _ref2$lazyLoad === void 0 ? false : _ref2$lazyLoad,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? "md" : _ref2$size,
      renderFallback = _ref2.renderFallback,
      _onError = _ref2.onError;

  var _sizeValue2 = sizeValue(size),
      diameter = _sizeValue2.diameter;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      useFallback = _useState2[0],
      setUseFallback = _useState2[1];

  return /*#__PURE__*/_react.default.createElement(BaseAvatar, {
    src: src,
    initials: initials,
    size: size,
    renderAvatar: function renderAvatar() {
      return renderFallback && useFallback ? renderFallback({
        diameter: diameter
      }) : /*#__PURE__*/_react.default.createElement(_LazyImage.LazyImage, {
        onError: function onError(e) {
          if (_onError) {
            _onError(e);
          }

          setUseFallback(true);
        },
        preload: !lazyLoad,
        width: diameter,
        height: diameter,
        borderRadius: diameter,
        src: src
      });
    }
  });
};

exports.Avatar = Avatar;
Avatar.displayName = "Avatar";
//# sourceMappingURL=Avatar.js.map